import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './content-list-with-category.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var ContentListWithCategory = /** @class */ (function (_super) {
    tslib_1.__extends(ContentListWithCategory, _super);
    function ContentListWithCategory(element) {
        return _super.call(this, element) || this;
    }
    ContentListWithCategory.prototype.init = function () {
        this.containerChips = this.element.querySelector('.content-list-with-category__chips');
        this.containerDescription = this.element.querySelector('.content-list-with-category__description');
        this.containerSlider = this.element.querySelector('.content-list-with-category__swiper');
        this.sliderPagination = this.element.querySelector('.slider__pagination');
        this.sliderNext = this.element.querySelector('.slider__nav--next');
        this.sliderPrev = this.element.querySelector('.slider__nav--prev');
        this.varSliderCreated = false;
        this.localStoragePbbIndex = Number(sessionStorage.getItem('activeChipIndex'));
        this.createCategories();
    };
    ContentListWithCategory.prototype.bindEvents = function () {
    };
    // extending functionality for PPB 'southafrica/personal'
    ContentListWithCategory.prototype.chipActiveStateCheck = function () {
        window.addEventListener('DOMContentLoaded', function (event) {
            var navigationEntries = (window.performance &&
                typeof window.performance.getEntriesByType === 'function')
                ? window.performance.getEntriesByType('navigation')
                : [];
            var navEntry = navigationEntries.length > 0 ? navigationEntries[0] : null;
            var isBackOrForward = navEntry && navEntry.type === 'back_forward';
            var isReload = navEntry && navEntry.type === 'reload';
            var activeChipIndex = sessionStorage.getItem('activeChipIndex');
            var chips = document.querySelectorAll('.content-list-with-category__chips--item');
            // UAT testing link to change to southafrica/personal
            var ppbPath = '/southafrica/personal';
            function chipClickHandler(event) {
                sessionStorage.setItem('activeChipIndex', Array.from(chips).indexOf(event.currentTarget));
            }
            chips.forEach(function (chip) {
                chip.removeEventListener('click', chipClickHandler);
            });
            chips.forEach(function (chip) {
                chip.addEventListener('click', chipClickHandler);
            });
            // execute if back or forward/reload button and if PPB
            if (isBackOrForward && window.location.pathname === ppbPath && activeChipIndex !== null || isReload && window.location.pathname && activeChipIndex !== null) {
                chips.forEach(function (chip) { return chip.classList.remove('active'); });
                if (activeChipIndex !== null) {
                    chips.forEach(function (chip) { return chip.classList.remove('active'); });
                    var activeChip = chips[activeChipIndex];
                    activeChip.click();
                }
            }
            else {
                chips[0].classList.add('active');
            }
            // end PPB check
        });
    };
    ContentListWithCategory.prototype.createCategories = function () {
        var _this = this;
        var output = "";
        var index = 0;
        jsonDataContentListWithCategory.forEach(function (category) {
            var icon = "";
            if (category.icon) {
                if (category.icon !== '') {
                    var iconPath = category.icon; // Full icon path
                    var pathParts = iconPath.split('/'); // Split the path into parts
                    var iconNameWithExt = pathParts[pathParts.length - 1]; // Last part, e.g., 'icon-ball.svg'
                    var iconName = iconNameWithExt.replace('.svg', ''); // Remove the '.svg' extension	
                    // Set the path as everything before icon name
                    var dataPath = pathParts.slice(0, pathParts.length - 1).join('/') + '/';
                    // Check if the icon path does not start with '/assets'
                    dataPath = '/file_source' + dataPath; // Prepend '/file_source' to the path
                    icon = "<div class=\"content-list-with-category__chips--item__icon\">\n\t\t\t\t\t\t<i data-component=\"icon\"\n\t\t\t\t\t\t\tdata-icon=\"" + iconName + "\"\n\t\t\t\t\t\t\tdata-path=\"" + dataPath + "\"\n\t\t\t\t\t\t\tclass=\"icon js-content-list-with-category-icon\">\n\t\t\t\t\t\t</i>\n\t\t\t\t\t</div>";
                }
            }
            if (index === 0) {
                output += "<div class=\"content-list-with-category__chips--item active\" data-index=\"" + index + "\">\n\t\t\t\t\t\t" + icon + "\n\t\t\t\t\t\t<div class=\"bodyTextSmall content-list-with-category__chips--item__text\">" + category.name + "</div>\n\t\t\t\t\t</div>";
                _this.containerDescription.innerHTML = category.description;
            }
            else {
                output += "<div class=\"content-list-with-category__chips--item\" data-index=\"" + index + "\">\n\t\t\t\t\t\t" + icon + "\n\t\t\t\t\t\t<div class=\"bodyTextSmall content-list-with-category__chips--item__text\">" + category.name + "</div>\n\t\t\t\t\t</div>";
            }
            index++;
        });
        this.containerChips.innerHTML = output;
        this.chipActiveStateCheck();
        this.createSliderItems(jsonDataContentListWithCategory[0].items);
        this.createCategoryClick();
        this.setupIcons();
    };
    ContentListWithCategory.prototype.createCategoryClick = function () {
        var _this = this;
        var chips = Array.from(this.containerChips.querySelectorAll('.content-list-with-category__chips--item'));
        chips.map(function (chip) { return chip.addEventListener('click', function (event) {
            chips.forEach(function (chip) {
                chip.classList.remove('active');
            });
            chip.classList.add('active');
            var indexChip = chip.getAttribute('data-index');
            _this.createSliderItems(jsonDataContentListWithCategory[parseInt(indexChip)].items);
            _this.containerDescription.innerHTML = jsonDataContentListWithCategory[parseInt(indexChip)].description;
        }); });
    };
    ContentListWithCategory.prototype.createSliderItems = function (items) {
        if (items === void 0) { items = []; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var output, _i, items_1, item, thumbnail, thumbHTML, thumbnail, thumbHTML, container;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        output = "";
                        _i = 0, items_1 = items;
                        _a.label = 1;
                    case 1:
                        if (!(_i < items_1.length)) return [3 /*break*/, 10];
                        item = items_1[_i];
                        output += "<div class=\"swiper-slide\">\n\t\t\t\t<div class=\"content-list-with-category__item ui-kit__palette--shadow\">";
                        if (!item.isVideo) return [3 /*break*/, 7];
                        output += "<div class=\"content-list-with-category__item--video\">";
                        if (!item.video.youtube_id) return [3 /*break*/, 2];
                        thumbnail = item.video.desktop || "https://img.youtube.com/vi/" + item.video.youtube_id + "/hqdefault.jpg";
                        thumbHTML = encodeURIComponent("\n\t\t\t\t\t\t<div class=\"content-list-with-category__play-button gradient-orange\">\n\t\t\t\t\t\t\t <i data-component=\"icon\" data-icon=\"icon-btn-play\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\"\n\t\t\t\t\t\t\t\tclass=\"icon \"><!--?xml version=\"1.0\" encoding=\"UTF-8\"?--><svg xmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t\t\t\txmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" version=\"1.1\">\n\t\t\t\t\t\t\t\t<!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch -->\n\t\t\t\t\t\t\t\t<title>icon-btn-play</title>\n\t\t\t\t\t\t\t\t<desc>Created with Sketch.</desc>\n\t\t\t\t\t\t\t\t<defs>\n\t\t\t\t\t\t\t\t\t<linearGradient xy=\"100%\" id=\"gradient\">\n\t\t\t\t\t\t\t\t\t<stop stop-color=\"#fff\" offset=\"0%\"></stop>\n\t\t\t\t\t\t\t\t\t<stop stop-color=\"#fff\" offset=\"100%\"></stop>\n\t\t\t\t\t\t\t\t\t</linearGradient>\n\t\t\t\t\t\t\t\t</defs>\n\t\t\t\t\t\t\t\t<g id=\"Standard-Bank---Icon-Setup\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"\n\t\t\t\t\t\t\t\t\ttransform=\"translate(-484.000000, -1861.000000)\">\n\t\t\t\t\t\t\t\t\t<g id=\"icon-btn-play\" transform=\"translate(486.000000, 1863.000000)\" stroke=\"#FFFFFF\" stroke-width=\"4\">\n\t\t\t\t\t\t\t\t\t<circle id=\"Oval\" cx=\"30\" cy=\"30\" r=\"30\"></circle>\n\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\td=\"M39.502,31.354 L25.52,39.861 C25.2113106,40.0489242 24.8252441,40.0556736 24.5101745,39.8786543 C24.1951049,39.7016349 24.0000601,39.3683927 24,39.007 L24,21.993 C24.0000601,21.6316073 24.1951049,21.2983651 24.5101745,21.1213457 C24.8252441,20.9443264 25.2113106,20.9510758 25.52,21.139 L39.502,29.646 C39.7999242,29.8275011 39.981727,30.1511426 39.981727,30.5 C39.981727,30.8488574 39.7999242,31.1724989 39.502,31.354 Z\"\n\t\t\t\t\t\t\t\t\t\tid=\"Shape\"></path>\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<img class=\"video-thumbnail\" src=\"" + thumbnail + "\" alt=\"" + item.title + "\">\n\t\t\t\t\t");
                        output += "<div class=\"content-list-with-category__container\" data-id=\"link_content_content\" data-intent=\"Informational\" data-scope=\"contentListWithCategory\" data-text=\"" + item.title + " | watch video click\">\n\t\t\t\t\t\t<div class=\"content-list-with-category__player js-video-play\" data-youtube-id=\"" + item.video.youtube_id + "\">\n\t\t\t\t\t\t\t" + decodeURIComponent(thumbHTML) + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"content-list-with-category__playercontent\">\n\t\t\t\t\t\t\t<div class=\"content-list-with-category__player--close-button js-video-close\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-times\"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>";
                        return [3 /*break*/, 6];
                    case 2:
                        if (!item.video.video_file) return [3 /*break*/, 5];
                        thumbnail = item.video.desktop;
                        if (!!thumbnail) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.captureThumbnailFromVideo(item.video.video_file)];
                    case 3:
                        thumbnail = _a.sent();
                        _a.label = 4;
                    case 4:
                        thumbHTML = encodeURIComponent("\n\n\t\t\t\t\t\t<div class=\"content-list-with-category__play-button gradient-orange\">\n\t\t\t\t\t\t\t <i data-component=\"icon\" data-icon=\"icon-btn-play\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\"\n\t\t\t\t\t\t\t\tclass=\"icon \"><!--?xml version=\"1.0\" encoding=\"UTF-8\"?--><svg xmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t\t\t\txmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" version=\"1.1\">\n\t\t\t\t\t\t\t\t<!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch -->\n\t\t\t\t\t\t\t\t<title>icon-btn-play</title>\n\t\t\t\t\t\t\t\t<desc>Created with Sketch.</desc>\n\t\t\t\t\t\t\t\t<defs>\n\t\t\t\t\t\t\t\t\t<linearGradient xy=\"100%\" id=\"gradient\">\n\t\t\t\t\t\t\t\t\t<stop stop-color=\"#fff\" offset=\"0%\"></stop>\n\t\t\t\t\t\t\t\t\t<stop stop-color=\"#fff\" offset=\"100%\"></stop>\n\t\t\t\t\t\t\t\t\t</linearGradient>\n\t\t\t\t\t\t\t\t</defs>\n\t\t\t\t\t\t\t\t<g id=\"Standard-Bank---Icon-Setup\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"\n\t\t\t\t\t\t\t\t\ttransform=\"translate(-484.000000, -1861.000000)\">\n\t\t\t\t\t\t\t\t\t<g id=\"icon-btn-play\" transform=\"translate(486.000000, 1863.000000)\" stroke=\"#FFFFFF\" stroke-width=\"4\">\n\t\t\t\t\t\t\t\t\t<circle id=\"Oval\" cx=\"30\" cy=\"30\" r=\"30\"></circle>\n\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\td=\"M39.502,31.354 L25.52,39.861 C25.2113106,40.0489242 24.8252441,40.0556736 24.5101745,39.8786543 C24.1951049,39.7016349 24.0000601,39.3683927 24,39.007 L24,21.993 C24.0000601,21.6316073 24.1951049,21.2983651 24.5101745,21.1213457 C24.8252441,20.9443264 25.2113106,20.9510758 25.52,21.139 L39.502,29.646 C39.7999242,29.8275011 39.981727,30.1511426 39.981727,30.5 C39.981727,30.8488574 39.7999242,31.1724989 39.502,31.354 Z\"\n\t\t\t\t\t\t\t\t\t\tid=\"Shape\"></path>\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<img class=\"video-thumbnail\" src=\"" + thumbnail + "\" alt=\"" + item.title + "\" data-original-html=\"" + thumbHTML + "\">\n\t\t\t\t\t\t\n\t\t\t\t\t");
                        output += "<div class=\"content-list-with-category__container\" data-id=\"link_content_content\" data-scope=\"contentListWithCategory\" data-intent=\"Informational\" data-text=\"" + item.title + " | watch video click\">\n\t\t\t\t\t\t<div class=\"content-list-with-category__player js-video-play\" data-video-file=\"" + item.video.video_file + "\">\n\t\t\t\t\t\t\t" + decodeURIComponent(thumbHTML) + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"content-list-with-category__playercontent\">\n\t\t\t\t\t\t\t<div class=\"content-list-with-category__player--close-button js-video-close\"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>";
                        return [3 /*break*/, 6];
                    case 5:
                        if (item.video.id) {
                            // Optional: handle other video sources like Vidavee
                            output += "<div class=\"content-list-with-category__container\">\n\t\t\t\t\t\t<div class=\"content-list-with-category__player js-video-play\" data-vidavee-id=\"" + item.video.id + "\">\n\t\t\t\t\t\t\t<div class=\"content-list-with-category__play-button gradient-orange\">\n\t\t\t\t\t\t\t\t <i data-component=\"icon\" data-icon=\"icon-btn-play\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\"\n\t\t\t\t\t\t\t\t\tclass=\"icon \"><!--?xml version=\"1.0\" encoding=\"UTF-8\"?--><svg xmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t\t\t\t\txmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" version=\"1.1\">\n\t\t\t\t\t\t\t\t\t<!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch -->\n\t\t\t\t\t\t\t\t\t<title>icon-btn-play</title>\n\t\t\t\t\t\t\t\t\t<desc>Created with Sketch.</desc>\n\t\t\t\t\t\t\t\t\t<defs>\n\t\t\t\t\t\t\t\t\t\t<linearGradient xy=\"100%\" id=\"gradient\">\n\t\t\t\t\t\t\t\t\t\t<stop stop-color=\"#fff\" offset=\"0%\"></stop>\n\t\t\t\t\t\t\t\t\t\t<stop stop-color=\"#fff\" offset=\"100%\"></stop>\n\t\t\t\t\t\t\t\t\t\t</linearGradient>\n\t\t\t\t\t\t\t\t\t</defs>\n\t\t\t\t\t\t\t\t\t<g id=\"Standard-Bank---Icon-Setup\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"\n\t\t\t\t\t\t\t\t\t\ttransform=\"translate(-484.000000, -1861.000000)\">\n\t\t\t\t\t\t\t\t\t\t<g id=\"icon-btn-play\" transform=\"translate(486.000000, 1863.000000)\" stroke=\"#FFFFFF\" stroke-width=\"4\">\n\t\t\t\t\t\t\t\t\t\t<circle id=\"Oval\" cx=\"30\" cy=\"30\" r=\"30\"></circle>\n\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\td=\"M39.502,31.354 L25.52,39.861 C25.2113106,40.0489242 24.8252441,40.0556736 24.5101745,39.8786543 C24.1951049,39.7016349 24.0000601,39.3683927 24,39.007 L24,21.993 C24.0000601,21.6316073 24.1951049,21.2983651 24.5101745,21.1213457 C24.8252441,20.9443264 25.2113106,20.9510758 25.52,21.139 L39.502,29.646 C39.7999242,29.8275011 39.981727,30.1511426 39.981727,30.5 C39.981727,30.8488574 39.7999242,31.1724989 39.502,31.354 Z\"\n\t\t\t\t\t\t\t\t\t\t\tid=\"Shape\"></path>\n\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"content-list-with-category__playercontent\">\n\t\t\t\t\t\t\t<div class=\"content-list-with-category__player--close-button js-video-close\"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>";
                        }
                        _a.label = 6;
                    case 6:
                        output += "</div>";
                        return [3 /*break*/, 8];
                    case 7:
                        // IMAGE block
                        output += "\n\t\t\t\t\t<div class=\"content-list-with-category__item--image\">\n\t\t\t\t\t\t<picture>\n\t\t\t\t\t\t\t<source srcset=\"" + item.images.desktop + "\" media=\"(min-width: 1024px)\">\n\t\t\t\t\t\t\t<source srcset=\"" + item.images.tablet + "\" media=\"(min-width: 768px)\">\n\t\t\t\t\t\t\t<img class=\"responsive-image " + item.images.modifiers + "\" src=\"" + item.images.desktop + "\" srcset=\"" + item.images.mobile + "\" alt=\"\">\n\t\t\t\t\t\t</picture>\n\t\t\t\t\t</div>";
                        _a.label = 8;
                    case 8:
                        output += "\n\t\t\t\t<div class=\"title title--module-sub-title content-list-with-category__item--title\">" + item.title + "</div>\n\t\t\t\t<div class=\"bodyText content-list-with-category__item--description\">" + item.description + "</div>\n\t\t\t\t<div class=\"content-list-with-category__item--link\">\n\t\t\t\t\t<a href=\"" + item.link.url + "\" class=\"link\" data-id=\"" + item.link.dataid + "\" data-scope=\"" + item.link.datascope + "\" data-intent=\"" + item.link.dataintent + "\" data-text=\"" + item.link.datatext + "\">\n\t\t\t\t\t\t<span class=\"link__text\">" + item.link.text + "</span>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>";
                        _a.label = 9;
                    case 9:
                        _i++;
                        return [3 /*break*/, 1];
                    case 10:
                        container = this.containerSlider.querySelector('.js-cards');
                        container.innerHTML = output;
                        this.createSlider();
                        this.attachVideoHandlers();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Extract thumbnail from the uploaded video file URL
    ContentListWithCategory.prototype.captureThumbnailFromVideo = function (videoUrl) {
        return new Promise(function (resolve) {
            var video = document.createElement('video');
            video.crossOrigin = 'anonymous';
            video.preload = 'metadata';
            video.src = videoUrl;
            // Wait for metadata so we can seek
            video.addEventListener('loadedmetadata', function () {
                // Seek to 1 second or 0 if shorter duration
                var seekTime = Math.min(1, video.duration / 2);
                video.currentTime = seekTime;
            });
            // Capture frame when seeked
            video.addEventListener('seeked', function () {
                var canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                var ctx = canvas.getContext('2d');
                if (!ctx)
                    return resolve('');
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                var imgData = canvas.toDataURL('image/jpeg');
                resolve(imgData);
            });
            video.addEventListener('error', function () {
                console.warn('Error loading video for thumbnail:', videoUrl);
                resolve('');
            });
        });
    };
    ContentListWithCategory.prototype.attachVideoHandlers = function () {
        var players = document.querySelectorAll('.js-video-play');
        var activePlayer = null;
        players.forEach(function (el) {
            if (el._hasClickHandler)
                return;
            el._hasClickHandler = true;
            var youtubeId = el.getAttribute('data-youtube-id');
            var videoFile = el.getAttribute('data-video-file');
            var vidaveeId = el.getAttribute('data-vidavee-id');
            el.addEventListener('click', function handleClick() {
                // Stop the currently active video
                if (activePlayer && activePlayer !== el) {
                    stopVideoPlayback(activePlayer);
                }
                // If already active, do nothing
                if (activePlayer === el)
                    return;
                activePlayer = el;
                el.setAttribute('data-original-html', encodeURIComponent(el.innerHTML));
                // Clear play button
                el.innerHTML = '';
                if (youtubeId) {
                    var iframe = document.createElement('iframe');
                    iframe.src = "https://www.youtube.com/embed/" + youtubeId + "?autoplay=1";
                    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
                    iframe.frameBorder = '0';
                    iframe.allowFullscreen = true;
                    iframe.style.width = '100%';
                    iframe.style.height = '168px';
                    el.appendChild(iframe);
                }
                else if (videoFile) {
                    var video = document.createElement('video');
                    video.src = videoFile;
                    video.controls = true;
                    video.autoplay = true;
                    video.style.width = '100%';
                    el.appendChild(video);
                }
                else if (vidaveeId) {
                    var script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.src = "https://tribeca.vidavee.com/publish/trh/embedAsset.js?responsive=true&d=" + vidaveeId + "&customHTML5player=sbv2";
                    el.appendChild(script);
                }
            });
        });
        //stop playback and restoreplay button
        function stopVideoPlayback(el) {
            // Stop MP4
            var video = el.querySelector('video');
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
            // Stop YouTube
            var iframe = el.querySelector('iframe');
            if (iframe && iframe.src.includes('youtube.com')) {
                iframe.src = '';
            }
            // Remove Vidavee embed script
            var script = el.querySelector('script[src*="vidavee"]');
            if (script) {
                script.remove();
            }
            // Restore thumbnail & play button
            var originalHTML = el.getAttribute('data-original-html');
            if (originalHTML) {
                el.innerHTML = decodeURIComponent(originalHTML);
                // Allow re-click to play again
                setTimeout(function () {
                    var newEl = el; // closure reference
                    newEl.addEventListener('click', function handleClickAgain() {
                        activePlayer = null;
                        newEl.dispatchEvent(new Event('click'));
                    }, { once: true });
                }, 0);
            }
            activePlayer = null;
        }
    };
    ContentListWithCategory.prototype.createSlider = function () {
        var _this = this;
        if (!this.varSliderCreated) {
            this.varSliderCreated = true;
        }
        else {
            this.slider.destroy();
        }
        var itemsCount = this.containerSlider.querySelectorAll('.swiper-slide').length;
        var slidesPerView = 3; // Default to 3 items per view
        // If there are 4 or more items, enable pagination and slider navigation
        if (itemsCount >= 4) {
            // this.sliderPagination.style.display = 'inline-block';
            this.sliderNext.style.display = 'inline-block';
            this.sliderPrev.style.display = 'inline-block';
        }
        else {
            // Hide pagination/navigation controls when there are fewer than 4 items
            this.sliderPagination.style.display = 'none';
            this.sliderNext.style.display = 'none';
            this.sliderPrev.style.display = 'none';
        }
        // Set the number of slides per view depending on the number of items
        if (itemsCount === 1) {
            slidesPerView = 1;
            this.containerSlider.querySelector('.swiper-slide').classList.add('single-item');
        }
        else if (itemsCount === 2) {
            slidesPerView = 2;
        }
        else if (itemsCount === 3) {
            slidesPerView = 3;
        }
        else if (itemsCount >= 4) {
            slidesPerView = 3;
        }
        this.slider = new Swiper(this.containerSlider, {
            slidesPerView: slidesPerView,
            centeredSlides: false,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                767: {
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                },
                580: {
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                }
            },
            freeMode: false,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            },
        });
        // Add resize listener to ensure proper layout when resizing
        window.addEventListener('resize', function () {
            _this.slider.update();
        });
    };
    ContentListWithCategory.prototype.setupIcons = function () {
        var _this = this;
        var icons = Array.from(document.querySelectorAll('.js-content-list-with-category-icon'));
        icons.forEach(function (icon) {
            var dataIcon = icon.getAttribute('data-icon');
            var dataPath = icon.getAttribute('data-path');
            _this.getIcon(icon, dataIcon, dataPath);
        });
    };
    ContentListWithCategory.prototype.getIcon = function (container, icon, path) {
        if (container === void 0) { container = undefined; }
        if (icon === void 0) { icon = ''; }
        if (path === void 0) { path = ''; }
        var iconUrl = "" + path + icon + ".svg";
        this.http.get(iconUrl).then(function (response) {
            container.innerHTML = response.data; // Set the SVG content in the icon container
        });
    };
    return ContentListWithCategory;
}(Base));
export { ContentListWithCategory };



//////////////////
// WEBPACK FOOTER
// ./components/content-list-with-category/content-list-with-category.component.ts
// module id = 740
// module chunks = 0